import { dateInputValue, recordDateRange } from './recordQueries.js'

// 仅接受真实本地自然日，避免UTC偏移和无效日期自动进位。
export function parsePickerDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(year, month - 1, day, 12)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null
}
export function pickerMonth(value) {
  const date = parsePickerDate(value) || new Date()
  return dateInputValue(new Date(date.getFullYear(), date.getMonth(), 1)).slice(0, 7)
}
export function shiftPickerMonth(month, offset) {
  const [year, index] = month.split('-').map(Number)
  return dateInputValue(new Date(year, index - 1 + offset, 1)).slice(0, 7)
}
export function pickerMonthDays(month) {
  const [year, index] = month.split('-').map(Number)
  const first = new Date(year, index - 1, 1, 12)
  const weekday = first.getDay()
  return Array.from({ length: 42 }, (_, i) => {
    const date = new Date(year, index - 1, 1 - weekday + i, 12)
    const value = dateInputValue(date)
    return { value, day: date.getDate(), current: value.startsWith(month) }
  })
}
export function pickerDateDisabled(value, min = '', max = '') {
  return !parsePickerDate(value) || Boolean(min && value < min) || Boolean(max && value > max)
}
export function orderedPickerRange(first, second) {
  return first <= second ? { start: first, end: second } : { start: second, end: first }
}
export function pickerShortcutRange(days, now = new Date()) {
  return recordDateRange(days, now)
}
export function movePickerDate(value, days) {
  const date = parsePickerDate(value)
  date.setDate(date.getDate() + days)
  return dateInputValue(date)
}
export function movePickerDateMonth(value, offset) {
  const date = parsePickerDate(value)
  const target = new Date(date.getFullYear(), date.getMonth() + offset + 1, 0, 12)
  target.setDate(Math.min(date.getDate(), target.getDate()))
  return dateInputValue(target)
}
